import React, { Suspense, Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ReactTable from "react-table";
import { Popconfirm } from "antd";
import { Button, ButtonGroup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { closeCustomModal, openCustomModal } from "components/custom/modals";
import filterCaseInsensitive from "components/custom/forms/react-table-case-insensitive";
import {
    getOrderExportLayouts,
    updateOrderExportLayout,
    deleteOrderExportLayout,
    createOrderExportLayout
} from "api/menu/master-files/order-export-layouts/actions";

const EditModal = React.lazy(() =>
    import("components/menu/master-files/order-export-layouts/edit-modal"));

class OrderExportLayoutsMain extends Component {
    constructor(props) {
        super(props);

        this.modalOpen = this.modalOpen.bind(this);

        this.props.getOrderExportLayouts();
    }

    modalOpen = (id = false) => {
        const modalObj = {
            id: `edit-modal-${id}`,
            header: `${id !== false ? "Update" : "Create"} Order Export Layout`,
            size: "md",
            children: (
                <Suspense fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                    <EditModal
                        id={id}
                        onCancel={() => this.props.closeCustomModal(modalObj)}
                        onSubmit={(data) => {
                            if (id) {
                                this.props.updateOrderExportLayout(id, data, res => {
                                    if (res) this.props.closeCustomModal(modalObj);
                                });
                            } else {
                                this.props.createOrderExportLayout(data, res => {
                                    if (res) this.props.closeCustomModal(modalObj);
                                });
                            }
                            // this.props.fetchMiscChargeTypes(true);
                        }}
                    />
                </Suspense>
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    };

    render() {
        const {
            loading,
            orderLayouts,
            deleteOrderExportLayout
        } = this.props;

        const classNameFlexCenter = "d-flex justify-content-center align-items-center";

        return (
            <div className="dashboard">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h3 className="mb-0">
                        Order Export Layouts
                    </h3>
                    <button
                        className="btn btn-success"
                        onClick={() => this.modalOpen()}
                    >
                        Add New Layout
                    </button>
                </div>

                <div>
                    <ReactTable
                        data={orderLayouts}
                        headerClassName="table-header"
                        columns={[{
                            Header: "Name",
                            accessor: "name",
                        }, {
                            Header: "Actions",
                            id: "actions",
                            className: classNameFlexCenter,
                            Cell: ({ original }) => (
                                <ButtonGroup>
                                    <Button
                                        size="sm"
                                        onClick={() => this.modalOpen(original.orderExportLayoutId)}
                                    >
                                        <FontAwesomeIcon icon="pen" title="Update" />
                                    </Button>
                                    <Popconfirm
                                        title={`Delete "${original.name}"?`}
                                        onConfirm={() =>
                                            deleteOrderExportLayout(original.orderExportLayoutId)}
                                        placement="bottomRight"
                                        okText="Yes"
                                        cancelText="Cancel"
                                    >
                                        <Button variant="danger" size="sm">
                                            <FontAwesomeIcon icon="times" />
                                        </Button>
                                    </Popconfirm>
                                </ButtonGroup>
                            ),
                            filterable: false,
                            width: 100
                        }]}
                        pageSize={Math.max(20, orderLayouts.length)}
                        showPagination={false}
                        resizable
                        className="-striped -highlight"
                        loading={loading}
                        filterable
                        defaultFilterMethod={filterCaseInsensitive}
                        style={{
                            height: "calc(100vh - 140px)",
                        }}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    orderLayouts: state.orderExportLayouts.orderLayouts
});

const mapStateToDispatch = dispatch => ({
    openCustomModal: bindActionCreators(openCustomModal, dispatch),
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

    getOrderExportLayouts: bindActionCreators(getOrderExportLayouts, dispatch),
    deleteOrderExportLayout: bindActionCreators(deleteOrderExportLayout, dispatch),
    updateOrderExportLayout: bindActionCreators(updateOrderExportLayout, dispatch),
    createOrderExportLayout: bindActionCreators(createOrderExportLayout, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(OrderExportLayoutsMain);
